/*
 * This Application Was Designed, Developed & Maintained with {❤️ + ☕️} by Eng. Golden. T. Chimusinde. Copyright (c) 2020.
 */

require('./bootstrap');

window.Vue = require('vue');
import 'bootstrap/dist/js/bootstrap.min.js';

Vue.component('slideshow-component', require('./components/SlideShowComponent').default);

const app = new Vue({
    el: '#app',
});



